import linkRuleHover from '../../../../common/algorithms/link-rule-hover';

const dark = (params) => linkRuleHover(params);

export default dark;
